import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { TOPIC_STATUS } from "src/helpers/const";
import { TopicStatus } from "src/types/graphql";
import { TopicsFilters } from "./types";

/**
 * Types
 */
interface Props {
  filters: TopicsFilters;
  updateFilters: React.Dispatch<React.SetStateAction<TopicsFilters>>;
}

const TopicsStatusFilter: React.FC<Props> = ({ filters, updateFilters }) => {
  const handleChange = (event: any) => {
    updateFilters({
      ...filters,
      status: event.target.value === "" ? undefined : event.target.value,
    });
  };
  return (
    <FormControl fullWidth>
      <InputLabel id={"topic-status-filter-label"}>Filter by Status</InputLabel>
      <Select
        label="Filter by Status"
        variant="outlined"
        value={filters.status || ""}
        labelId="topic-status-filter-label"
        onChange={handleChange}
        sx={{ width: "180px" }}
      >
        <MenuItem value="">—</MenuItem>
        {Object.values(TopicStatus).map((value) => (
          <MenuItem value={value} key={value}>
            {TOPIC_STATUS.get(value)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default TopicsStatusFilter;
